import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { ajax } from 'jquery';
import './index.css';

function validateUsername(input: string): boolean {
    const pattern = /^[a-zA-Z][a-zA-Z0-9]{5,19}$/;
    return pattern.test(input);
}

function validatePassword(input: string): boolean {
    const regex = /^[a-zA-Z0-9]{6,20}$/;
    return regex.test(input);
}

const Reg = () => {

    const usernameRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);
    const password2Ref = useRef<HTMLInputElement>(null);

    useEffect(() => {

    }, [])

    const postData = async () => {
        const username = usernameRef.current!.value;
        const password = passwordRef.current!.value;
        const password2 = password2Ref.current!.value;
        if (!validatePassword(password)) {
            alert('密码格式不正确！')
            return;
        }
        if (password !== password2) {
            alert('密码输入不一致！')
            return;
        }
        if (!validateUsername(username)) {
            alert('用户名格式不正确！')
            return;
        }

        const result = await ajax({
            method: "POST",
            url: `/api/v1/countryball_card/user`,
            data: {
                username, password
            }
        })
        if (result.status === 'success') {
            alert('注册成功，请登录')
            window.location.href = '/login'
        }
        if (result.status === 'failed') {
            alert(result.msg)
        }
    }

    return (
        <div className='page-wrap card-page myballs-page'>
            {
                <div className="login-page-content">
                    <h3 className="login-title">注册国家球日记账户</h3>
                    <div className="login-form">
                        <p className="input-title">用户名</p>
                        <input type="text" ref={usernameRef} placeholder='英文开头，6-20个英文字母或数字' />
                        <p className="input-title">密码</p>
                        <input type="password" ref={passwordRef} placeholder='6-20个英文字母或数字' />
                        <p className="input-title">再次输入密码</p>
                        <input type="password" ref={password2Ref} placeholder='再次输入密码' />
                    </div>
                    <div className="add-new-ball-box">
                        <a href="#" onClick={postData} className="common-btn add-new-ball">注册</a>
                        <a href="/login" className="common-link reg-link">已拥有账户？点此登录</a>
                    </div>
                </div>
            }
        </div >
    );
}

export default Reg